import { useTableActionContext } from '@aibees/elephant/context';
import { useFilterLabelsByOwnershipTab } from '@aibees/elephant/hooks/labels/use-label-ownership-tabs';
import { Label } from '@aibees/elephant/types/label';
import { useMemo } from 'react';

interface UseDisabledSelectAllParams {
  labels: Label[];
  isLabel: boolean;
}

export function useDisabledSelectAll({
  labels,
  isLabel,
}: UseDisabledSelectAllParams): boolean {
  const {
    labels: globalLabels,
    lists: globalLists,
    tabValue,
  } = useTableActionContext();
  const filterByOwnershipTab = useFilterLabelsByOwnershipTab();

  return useMemo(() => {
    const array = isLabel ? globalLabels : globalLists;

    const filteredLabels = filterByOwnershipTab(labels, tabValue);

    if (filteredLabels.length === 0) {
      return true;
    }

    const labelsIds = filteredLabels.map((x) => x.id);
    const arrayIds = new Set(array.map((x) => x.id));

    return labelsIds.every((id) => arrayIds.has(id));
  }, [
    globalLabels,
    globalLists,
    labels,
    isLabel,
    tabValue,
    filterByOwnershipTab,
  ]);
}
